<mat-form-field>
    <mat-label appRemoveAriaOwns>{{ 'forms.applicant-tracker.compensationType' | appTranslate }}</mat-label>
    <mat-select
        placeholder="{{ 'forms.applicant-tracker.selectAnOption' | appTranslate }}"
        name="jobPostingCompensation"
        #jobPostingCompensation="ngModel"
        [(ngModel)]="jobPosting.compensationType"
    >
        <mat-option *ngFor="let compensationType of compensationTypes" [value]="compensationType.value">
            {{ compensationType.label | appTranslate }}
        </mat-option>
        <mat-option>{{ 'forms.applicant-tracker.na' | appTranslate }}</mat-option>
    </mat-select>
    <mat-error *ngIf="jobPostingCompensation.invalid">{{ jobPostingCompensation.errors | formErrors }}</mat-error>
</mat-form-field>
